export default "__VITE_ASSET__Ddaj28rD__"